// extracted by mini-css-extract-plugin
export default {"fade":"Header_fade__P1AY2","enter":"Header_enter__ZxCJ4","active":"Header_active__fp0c7","header":"Header_header__544Et"};